import { render, staticRenderFns } from "./SuperClienteTiendaSelectComponent.vue?vue&type=template&id=4234bf75&"
import script from "./SuperClienteTiendaSelectComponent.vue?vue&type=script&lang=js&"
export * from "./SuperClienteTiendaSelectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports